<template>
    <section class="bg-account-pages vh-100 d-flex align-items-center bg-center position-relative">
        <div class="container" id="app">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="bg-white shadow">
                        <div class="p-4">
                            <div class="text-center mt-3">
                                <a href="/">
                                    <img src="../../../images/logo-dark.png" alt="" class="logo-dark" height="30" />
                                </a>
                                <p class="title-signup">비밀번호 재설정</p>
                            </div>
                            <div class="p-3">
                                
                                <form action="/anonymous/resetPw"
                                    method="post"
                                    @submit="resetPassword"
                                    class="av-invalid"
                                    id="frm-reset-password">
                                    
                                    <div class="mb-3">
                                        <input name="password" required="" placeholder="비밀번호"
                                            v-model="password"
                                            id="userpassword" type="password" class="form-control" value=""/>
                                    </div>
                                    <div class="mb-3">
                                        <input name="password" required="" placeholder="비밀번호 확인"
                                            v-model="password2"
                                            id="userpassword2" type="password" class="form-control" value=""/>
                                    </div>
                                    <div class="d-grid mt-3">
                                        <button id="submit-button" type="submit" value="Submit" class="btn btn-primary btn-none">변경하기</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end col -->
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>

</template>

<script>
import Swal from '../../../js/sweetalert2.min.js';
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

export default {
    data(){
        return {
            loginSuccess : false,
            token: "",
            password: "",
            password2: ""
        }
    },
    methods: {
        resetPassword: function(e){

            e.preventDefault();
            // 아이디 중복확인
            // 이메일 유효성 확인
            // 비밀번호 유효성 확인
            // 비밀번호끼리 일치하는 지 확인
            this.errors = [];

            if (!this.password) {
                this.errors.push('비밀번호를 입력해주세요.');
            } else if (this.password.length < 8) {
                this.errors.push('비밀번호를 8자리 이상 입력하세요.');
            } else if (this.password.length > 16) {
                this.errors.push('비밀번호를 16자리 이하로 입력하세요.');
            } else if (!this.validPassword(this.password)) {
                this.errors.push('비밀번호를 영문, 숫자, 특수문자 각 1회 이상 입력하세요.');
            } else if (this.password != this.password2) {
                this.errors.push('동일한 비밀번호를 입력해주세요.');
            }


            if (this.errors.length) {
                swal(this.errors[0]);
                return true;
            } else {
                
                var form = new FormData();
                form.append('token', this.$route.query.token);
                form.append('password', this.password);
                this.loginSuccess = false;
                Swal.showLoading();
                axios.post("/anonymous/resetPw/token", form)
                
                .then(response => {  
                    Swal.close();
                    if(response.status == 200){
                        var msg;
                        var code = response.data.code;
                        if(code == 10){
                            msg = '비밀번호가 재설정 되었습니다.\n 로그인 페이지로 이동합니다.';
                            this.loginSuccess = true;
                            setTimeout(() => {
                                location.href='/signin';
                            }, 1500);
                            swal(msg, {
                                buttons: false,
                                timer: 1500
                            });
                        } else {
                            if(code == 20){
                                msg = '존재하지 않는 이메일이거나, 탈퇴한 회원입니다. \n관리자에게 문의해주세요.';
                            } else if(code == 30){
                                msg = '이미 만료된 페이지입니다.\n이메일을 다시 전송해주세요.';
                                setTimeout(() => {
                                    this.$router.push('/resetpw/email');
                                }, 3000);
                            } else if(code == 40){
                                msg = '잘못된 페이지입니다.\n비밀번호를 다시 재설정해주세요.';
                                setTimeout(() => {
                                    this.$router.push('/resetpw/email');
                                }, 3000);
                            } else if(code == 50){
                                msg = '서버에 문제가 발생하여 비밀번호 재설정에 실패했습니다.\n관리자에게 문의해주세요.\n code -0';
                            } else if(code == -1){
                                msg = '서버에 문제가 발생하여 비밀번호 재설정에 실패했습니다.\n관리자에게 문의해주세요.\n code -1';
                            } else {
                                msg = '알 수 없는 문제가 발생하여 비밀번호 재설정에 실패했습니다.\n관리자에게 문의해주세요.\n code -2';
                            }
                            swal(msg, {
                                buttons: false,
                                timer: 3000
                            });
                        }

                    } else {
                        swal('서버에 문제가 발생하여 이메일 발송에 실패했습니다. \n 관리자에게 문의해주세요.\n code -3', {
                            buttons: false,
                            timer: 3000
                        });
                    }
                    
                }).catch(error => {
                    Swal.close();
                    swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
                });

            }
        },
        validPassword: function (password) {
            var re = /(?=.*\d)(?=.*[a-z]).{8,16}/;
            return re.test(password);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/ResetPwViaToken.vue